<template>
  <div class="change_box" @mouseover="showChooseBox" @mouseout="hideChooseBox">
    <div class="r_box">
      <p class="flag_box">
        <i :class="'flag X1 '+ fragClass"></i>
      </p>
      <p class="lang_code">{{ value }}</p>
      <p class="lang_arrow">
        <i :class="show ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
      </p>
    </div>
    <ul>
      <li
        v-for="(item, index) in options"
        :key="index"
        @click="ChangeLang(item.value, item.label)"
      >{{ item.label }}</li>
    </ul>
  </div>
</template>
<script>
export default {
  name: "ChangeLanguage",
  data() {
    return {
      show: false,
      langs: ["zh"],
      options: [
        {
          value: "en",
          class: "america",
          label: "English"
        },
        {
          value: "zh_cn",
          class: "china",
          label: "中文"
        }
        // {
        //   value: "ja",
        //   class: "japan",
        //   label: "日本語"
        // },
        // {
        //   value: "in",
        //   class: "indonesia",
        //   label: "Bahasa indonesia"
        // },
        // {
        //   value: "ms",
        //   class: "malaysia",
        //   label: "Melayu"
        // },
        // {
        //   value: "nl",
        //   class: "netherlands",
        //   label: "Nederlands"
        // },
        // {
        //   value: "es",
        //   class: "spain",
        //   label: "Español"
        // },
        // {
        //   value: "fr",
        //   class: "france",
        //   label: "Anglais"
        // },
        // {
        //   value: "ko",
        //   class: "south korea",
        //   label: "한국어"
        // },
        // {
        //   value: "de",
        //   class: "germany",
        //   label: "Deutsch"
        // }
      ],
      value: "ZH_CN",
      fragClass: "china"
    };
  },
  methods: {
    getNewDict(lang, dic) {
      let newLang = lang;
      let newDict = {};
      for (var obj in dic) {
        newDict[obj] = dic[obj][newLang];
      }
      return newDict;
    },
    ChangeLang(value) {
      this.$localStorage.set("languageCode", value);
      window.location.reload();
      // this.value = label;
      // this.show = false;

      // this.axios.get("/static/language/" + value + ".json").then(res => {
      //   this.$i18n.mergeLocaleMessage(value, res);
      //   this.$i18n.locale = value;
      //   for (let index = 0; index < this.options.length; index++) {
      //     if (this.options[index].value === value) {
      //       this.fragClass = this.options[index].class;
      //     }
      //   }
      //   // window.location.reload()
      // });
      // this.value = label;
    },
    showChooseBox() {
      this.show = true;
    },
    hideChooseBox() {
      this.show = false;
    },
    // 判断是不是有历史语言
    hisLang() {
      let lang = this.$localStorage.get("languageCode");
      if (lang === "" || lang == undefined) {
        return;
      } else {
        for (let index = 0; index < this.options.length; index++) {
          if (this.options[index].value === lang) {
            this.fragClass = this.options[index].class;
            this.value = this.options[index].label;
          }
        }
      }
    }
  },
  created() {
    this.hisLang();
  }
};
</script>
<style lang="scss" scoped>
.change_box {
  position: relative;
  line-height: 28px;
  cursor: pointer;
  .r_box {
    position: relative;
    width: 160px;
    height: 30px;
    line-height: 30px;
    box-sizing: border-box;
    color: #b3b7d1;
    overflow: hidden;
    p {
      float: left;
    }
    .lang_code {
      width: 100px;
      text-align: center;
    }
    .flag_box {
      padding: 0 7px;
      box-sizing: border-box;
      width: 30px;
      height: 30px;
    }
    .lang_arrow {
      float: right;
      width: 30px;
      text-align: center;
      i {
        font-size: 16px;
      }
    }
  }

  ul {
    position: absolute;
    display: none;
    right: 0;
    width: 180px;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
    background-color: #fff;
    color: #333;
    z-index: 5;
    li {
      padding: 10px;
    }
    li:hover {
      background-color: #eee;
    }
  }
}
.change_box:hover {
  ul {
    display: block;
  }
}
</style>


